import { useViewModel } from "../../../viewmodel/useViewModel";
import { ViewModelKeys } from "../../../viewmodel/ViewModelFactoryMap";

export function useDiagnosticsViewModel() {
  return useViewModel(ViewModelKeys.CONTENT_DISCREPANCIES_VIEW_MODEL);
}
